import script from "./AppNewHeaderIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNewHeaderIndex.vue?vue&type=script&setup=true&lang=js"

import "./AppNewHeaderIndex.vue?vue&type=style&index=0&id=29124964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29124964"]])

export default __exports__